module.exports = __webpack_public_path__ + "static/media/ra.3249f2c0.png";